
import Header from '../Header1';
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { useState, useRef, useEffect } from "react";
import DatePicker from "../../Component/DatePicker";
import ReactPaginate from "react-paginate";
import axiosInstance from '../../axiosInstance';
import CostTypePopup from './CostTypePopup';
import { ToastContainer, toast } from "react-toastify";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import CommonFooter from '../../CommonFooter/CommonFooter';
import { useGlobal } from '../../GlobalContext';

const CostType = () => {

  const { rolePermissionList } = useGlobal();

  // True when the role has the given permission for the named menu.
  const checkPermission = (menuName, permission) =>
    rolePermissionList.some((element) => element.name === menuName && element[permission] === true);


  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editData, setEditData] = useState(null);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const popupRef = useRef(null);

  const fetchData = async (search = '') => {
    try {
      const response = await axiosInstance.get(`/costsolution/costtype`, {
        params: { limit, skip, search }
      });
      if (Array.isArray(response.data.costtype)) {
        setTableData(response.data.costtype);
        setTotal(response.data.totalCount || 0);
        setTotalPages(Math.ceil((response.data.totalCount || 0) / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      setError(error.message);
      console.error("Fetch error:", error);
      toast.error("Failed to fetch cost types");
    }
  };

  useEffect(() => {
    fetchData(searchTerm);
  }, [skip, limit, reload, searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isPopupOpen]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0); // Reset skip when limit changes
  };

  const handleAddNewClick = (row) => {
    setEditData(row ? { id: row.id } : null);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev => prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]);
  };

  const handleDeleteRow = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDeleteRow = async () => {
    try {
      await axiosInstance.delete(`/costsolution/costtype/delete/${deleteId}`);
      toast.success("Row deleted successfully!");
      setTableData(prev => prev.filter(row => row.id !== deleteId));
      setTotal(prev => prev - 1);
      fetchData()
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting!");
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(0);
    setSkip(0);
  };

  return (
    <>
      <Header onSearch={handleSearch} />
      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>All Cost Type ({total})</h3>
          </div>
          <div className="right-header">

            {checkPermission("Cost Tag", "create_permission") && !isAnySelected && (
              <button id="addNewBtn" onClick={() => handleAddNewClick()}>
                Add New
              </button>
            )}
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style={{ width: "1px" }}>
                <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />
              </th>
              <th>S.No</th>
              <th>Code</th>
              <th>Name</th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map((row, index) => (
                <tr key={row.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleRowSelect(row.id)}
                    />
                  </td>
                  <td>{skip + tableData.indexOf(row) + 1}</td>
                  <td>{row.code}</td>
                  <td>{row.name}</td>
                  <td>{row.modifieddate}</td>
                  <td>

                    <div className="actions">

                      {checkPermission("Cost Tag", "edit_permission") && (
                        <span className="edit-icon">
                          <img
                            src={Vector}
                            alt="Edit Icon"
                            width="20"
                            height="20"
                            onClick={() => handleAddNewClick(row)} // ✅ Passes row data correctly
                          />
                        </span>
                      )}

                      {checkPermission("Cost Tag", "delete_permission") && (
                        <span
                          className="delete-icon"
                          onClick={() => handleDeleteRow(row.id)} // Ensure this matches the function name
                          style={{ cursor: "pointer" }}
                        >
                          <img src={Delete} alt="Delete Icon" width="40" height="40" />
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                {searchTerm && tableData.length === 0 && (
                  <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                    No CostType found matching "{searchTerm}"
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <CostTypePopup closePopup={closePopup} editData={editData} triggerReload={() => setReload(prev => !prev)} />
          </div>
        </div>
      )}
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={confirmDeleteRow}
        confirmText="Delete"
        cancelText="Cancel"
        onCancel={cancelDelete}
        title="Delete Confirmation"
        message="Are you sure you want to delete this cost type?"
      />
    </>
  );
};

export default CostType;
